//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name: "Summary",
	props: ["summary"],
  data() {
    return { }
  },
	filters: {
		currency(val) {
			return '$' + parseInt(val).toLocaleString()
		}
	}
}
